import Vue from 'vue'
const vue = new Vue();

// 获取token
export const TOKEN = '/oauth/token';
// 登陆
export const LOGIN = '/api/login/web';

// 注册
export const SIGNIN = '/api/companies';
// 短信接口
export const GET_MSG = '/api/login/sendcode';
// // 短信验证
export const CONFIRM_MSG = '/api/login/verifycode';

// 软件下载地址
export const APP_VERSIONS = '/api/login/versions';

// 企业详情
export const COM_INFO = '/api/companies';

// 企业信息修改
export const COM_UPDATE = '/api/companies/update';

// 发票修改
export const COM_INVOICE = '/api/invoice';
// 会员列表
export const USER_INDEX = '/api/users/index';
// 添加会员
export const ADD_USER = '/api/users';
// 添加会员
export const WEB_SHOW = '/api/users/webShow';
//编辑会员
export const UPDATE_USER = '/api/users/update';
// 删除会员
export const DEL_USER = '/api/users/del/';
// 禁用会员
export const DISABLE_USER = '/api/users/setstatus';
// 获取所有权限
export  const GET_AUTH = '/api/permission';
// 转让联系人
export const TRANSFER = '/api/users/transfer';
//修改权限
export const UPDATE_AUTH = '/api/permission/update';
// 上传图片
export const UPLOAD_IMG = '/api/file/uploadimg';
//查看部门信息
export const DEPARTMENT = '/api/department';
//编辑部门名称
export const DEPARTMENT_UPDATE = '/api/department/update';
//删除部门
export const DEPARTMENT_DELETE = '/api/department/delete';
//查看所有部门
export const DEPARTMENT_LIST = '/api/department/list'
//角色
export const ROLES = '/api/roles'
//角色
export const ROLESNAME = '/api/roles/name'
//角色
export const CHECK_ROLES = '/api/roles/check'
//修改权限
export const ROLES_PERSSION = '/api/roles/permission'
//获取职务列表
export const DUTY_LIST = '/api/duty/list'
//新增职务
export const DEPARTMENT_DUTY = '/api/department/duty'
//用户列表
export const WEB_USER_LIST = '/api/users/webUserList'
//修改用户密码
export const WEB_SET_PWD = '/api/users/webSetpwd'
//激活售点公司
export const ACTIVATION = '/api/companies/activation'
export const errcallback = function (err) {
    // vue.$Modal.error({
    //     content: '请求出错'
    // });
    console.error("请求出错"+err)
}



// WEBPACK FOOTER //
// ./src/Api.js